import { Pipe, PipeTransform } from "@angular/core";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { TranslationsProvider } from "../../core/translations.provider";

@Pipe({
    name: "rxDate",
    pure: false,
})
export class ReactiveDatePipe implements PipeTransform {
    constructor(private translationsProvider: TranslationsProvider) {}

    //changes date values format based on language
    transform(value: Date | string): Observable<string> {
        return this.translationsProvider.localeChanges.pipe(
            map((locale) => {
                const date = value instanceof Date ? value : new Date(value);

                const formatLocale = locale || "en-GB";

                return new Intl.DateTimeFormat(formatLocale, {
                    year: "numeric",
                    month: "2-digit",
                    day: "2-digit",
                }).format(date);
            }),
        );
    }
}



// WEBPACK FOOTER //
// C:/Repositories/wfa3/SupplierPortal/app/src/app/shared/pipes/reactive-date.pipe.ts